import { defaultClient as ApolloClient } from "@/main";
import {
  PROGRAM_MERGE, PROGRAM_DELETE, WORKOUT_MERGE, WORKOUT_DELETE, SET_MERGE, SET_DELETE, WORKOUT_SCHEDULE_MUTATE, WORKOUT_SCHEDULE_DELETE
} from "../../../graphql/program/programM";
import {
  GET_PROGRAM, GET_WORKOUT_SCHEDULES
} from "../../../graphql/program/programQ";

export const actions = {
  allProgram: async ({ commit }, payload) => {
    // commit("setLoading", true);
    return ApolloClient.query({
      query: GET_PROGRAM,
      variables: payload
    })
      .then(({ data }) => {
        commit("setProgram", data.allProgram);
        // commit("setLoading", false);
      })
      .catch(err => {
        // commit("setLoading", false);
        console.error(err);
      });
  },
  programMerge: async ({ dispatch }, payload) => {
    try {
      const response = await ApolloClient.mutate({
        mutation: PROGRAM_MERGE,
        variables: payload,
        update: (cache, { data: { programMerge } }) => {
          try {
            const data = cache.readQuery({
              query: GET_PROGRAM,
            });
            data.allProgram.edges.push({ node: programMerge });
            cache.writeQuery({
              query: GET_PROGRAM,
              data,
            });
          } catch (cacheError) {
            console.error("Error updating Apollo cache:", cacheError);
          }
        },
      });
      dispatch("allProgram");
      return response;
    } catch (error) {
      console.error("Error in programMerge action:", error.message);
      throw new Error(`Error in programMutate action. Full info: ${error.message}`);
    }
  },
  programDelete: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: PROGRAM_DELETE,
      variables: payload,
      update: cache => {
        try {
          const data = cache.readQuery({
            query: GET_PROGRAM
          });

          data.allProgram.edges = data.allProgram.edges.filter(
            el => +el.node.programId !== +payload.programId
          );

          cache.writeQuery({
            query: GET_PROGRAM,
            data
          });
        } catch (error) {
          throw new Error(
            `Error in programDelete update hook. Full info: ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allProgram");
      })
      .catch(err => {
        throw new Error(`Error in programDelete action. Full info: ${err}`);
      });
  },
  workoutMerge: async ({ dispatch }, payload) => {
    try {
      const response = await ApolloClient.mutate({
        mutation: WORKOUT_MERGE,
        variables: payload,
        update: (cache, { data: { workoutMerge } }) => {
          try {
            const data = cache.readQuery({
              query: GET_PROGRAM,
            });
            //data.allProgram.edges.push({ node: workoutMerge });
            cache.writeQuery({
              query: GET_PROGRAM,
              data,
            });
          } catch (cacheError) {
            console.error("Error updating Apollo cache:", cacheError);
          }
        },
      });
      dispatch("allProgram");
      return response;
    } catch (error) {
      console.error("Error in workoutMerge action:", error.message);
      throw new Error(`Error in workoutMerge action. Full info: ${error.message}`);
    }
  },
  workoutDelete: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: WORKOUT_DELETE,
      variables: payload,
      update: cache => {
        try {
          const data = cache.readQuery({
            query: GET_PROGRAM
          });

          // data.allProgram.edges = data.allProgram.edges.filter(
          //   el => +el.node.programId !== +payload.programId
          // );

          cache.writeQuery({
            query: GET_PROGRAM,
            data
          });
        } catch (error) {
          throw new Error(
            `Error in workoutDelete update hook. Full info: ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allProgram");
      })
      .catch(err => {
        throw new Error(`Error in workoutDelete action. Full info: ${err}`);
      });
  },
  setMerge: async ({ dispatch }, payload) => {
    try {
      const response = await ApolloClient.mutate({
        mutation: SET_MERGE,
        variables: payload,
        update: (cache, { data: { setMerge } }) => {
          try {
            const data = cache.readQuery({
              query: GET_PROGRAM,
            });
            //data.allProgram.edges.push({ node: workoutMerge });
            cache.writeQuery({
              query: GET_PROGRAM,
              data,
            });
          } catch (cacheError) {
            console.error("Error updating Apollo cache:", cacheError);
          }
        },
      });
      dispatch("allProgram");
      return response;
    } catch (error) {
      console.error("Error in setMerge action:", error.message);
      throw new Error(`Error in setMerge action. Full info: ${error.message}`);
    }
  },
  setDelete: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: SET_DELETE,
      variables: payload,
      update: cache => {
        try {
          const data = cache.readQuery({
            query: GET_PROGRAM
          });

          // data.allProgram.edges = data.allProgram.edges.filter(
          //   el => +el.node.programId !== +payload.programId
          // );

          cache.writeQuery({
            query: GET_PROGRAM,
            data
          });
        } catch (error) {
          throw new Error(
            `Error in setDelete update hook. Full info: ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allProgram");
      })
      .catch(err => {
        throw new Error(`Error in setDelete action. Full info: ${err}`);
      });
  },
  allWorkoutSchedules: async ({ commit }) => {
    try {
      const { data } = await ApolloClient.query({
        query: GET_WORKOUT_SCHEDULES,
        fetchPolicy: 'network-only' // or 'cache-first' depending on behavior you want
      });

      const schedules = data.allWorkoutSchedules.edges.map(edge => edge.node);
      commit("setWorkoutSchedules", schedules);
    } catch (error) {
      console.error("Error fetching allWorkoutSchedules:", error);
    }
  },
  workoutScheduleMerge: async ({ dispatch, commit }, payload) => {
    return ApolloClient.mutate({
      mutation: WORKOUT_SCHEDULE_MUTATE,
      variables: payload,
      update: (cache, { data }) => {
        try {
          console.log("Mutation response:", data);

          const newNode = data.workoutScheduleMutate.edges.node;
          if (!newNode) {
            console.error("No node found in the mutation response");
            return;
          }

          const existingData = cache.readQuery({
            query: GET_WORKOUT_SCHEDULES
          });

          let existingNodes = existingData.allWorkoutSchedules.edges.map(edge => edge.node);
          existingNodes = existingNodes.filter(item => item.seqNo !== newNode.seqNo);
          existingNodes.push(newNode);

          const newData = {
            allWorkoutSchedules: {
              ...existingData.allWorkoutSchedules,
              edges: existingNodes.map(node => ({ node }))
            }
          };

          cache.writeQuery({
            query: GET_WORKOUT_SCHEDULES,
            data: newData
          });

          commit("setWorkoutSchedules", newData.allWorkoutSchedules.edges.map(edge => edge.node));
        } catch (error) {
          console.error(`Error in workoutScheduleMerge update hook: ${error}`);
        }
      }
    })
      .then(() => {
        dispatch("allWorkoutSchedules");
      })
      .catch(err => {
        console.error(`Error in workoutScheduleMerge action: ${err}`);
      });
  },
  workoutScheduleDelete: async ({ dispatch, commit }, { seqNo }) => {
    return ApolloClient.mutate({
      mutation: WORKOUT_SCHEDULE_DELETE,
      variables: { seqNo },
      update: (cache, { data }) => {
        try {
          console.log("Delete Mutation Response:", data);

          const success = data.workoutScheduleDelete.success;
          if (!success) {
            console.error("Deletion unsuccessful:", data.workoutScheduleDelete.message);
            return;
          }

          const existingData = cache.readQuery({
            query: GET_WORKOUT_SCHEDULES
          });

          const updatedNodes = existingData.allWorkoutSchedules.edges.filter(
            edge => edge.node.seqNo !== seqNo
          );

          const newData = {
            allWorkoutSchedules: {
              ...existingData.allWorkoutSchedules,
              edges: updatedNodes
            }
          };

          cache.writeQuery({
            query: GET_WORKOUT_SCHEDULES,
            data: newData
          });

          commit("setWorkoutSchedules", newData.allWorkoutSchedules.edges.map(edge => edge.node));
        } catch (error) {
          console.error(`Error in workoutScheduleDelete update hook: ${error}`);
        }
      }
    })
      .then(() => {
        dispatch("allWorkoutSchedules");
      })
      .catch(err => {
        console.error(`Error in workoutScheduleDelete action: ${err}`);
      });
  }


};